import React from 'react'

const BinBig = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
            fill="none"
            viewBox="0 0 50 50"
        >
            <path
                fill="#F3BA2F"
                d="M49.246 31.048C45.907 44.44 32.343 52.59 18.948 49.252 5.559 45.912-2.592 32.346.748 18.954 4.087 5.56 17.652-2.591 31.042.748c13.394 3.339 21.544 16.906 18.205 30.3z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M25 15.867l-6.474 6.473-3.766-3.767L25 8.333l10.243 10.243-3.766 3.767L25 15.867zm-12.9 5.366L8.332 25l3.766 3.766 3.767-3.767-3.767-3.766zm6.426 6.427L25 34.133l6.476-6.476 3.769 3.765-.002.002L25 41.667l-10.24-10.24-.006-.006 3.772-3.76zm19.373-6.425l-3.767 3.767 3.767 3.766 3.767-3.767-3.767-3.766z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#fff"
                d="M28.82 24.998h.002L25 21.176 22.175 24l-.324.325-.67.67-.005.004.005.006 3.82 3.82 3.821-3.823.002-.002-.003-.002"
            ></path>
        </svg>
    )
}

export default BinBig